import React, { useState, useEffect, useRef } from 'react'
import {
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBTabContent,
  MDBTabPane,
} from 'mdbreact'
import { withRouter } from 'react-router-dom'
import BusinessQuote from './QuoteForm.business'
import IndividualQuote from './QuoteForm.individual'
import env from '../../environments/environment'
import './QuotationTabs.scss'

const BG_IMGS = {
  individual:
    'https://firebasestorage.googleapis.com/v0/b/totemic-bonus-239316.appspot.com/o/static%2Fimg.attendent.jpg?alt=media',
  business: `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fimg.new-small-business.jpg?alt=media`,
}

const QuotationTabs = (props) => {
  const recaptchaRef = useRef(props.useCaptcha ? React.createRef() : null)
  const [activeQuoteItem, setActiveQuoteItem] = useState('1')
  const [customerType, setCustomerType] = useState('individual')

  const isSmallBiz = activeQuoteItem === '4'

  const toggleQuoteTabs = (tab) => (e) => {
    if (activeQuoteItem !== tab) {
      setActiveQuoteItem(tab)
      if (recaptchaRef.current) window.grecaptcha.reset()
    }
  }

  const handleExternalTabChange = () => {
    switch (props.insuranceType) {
      case 'health':
        if (parseInt(activeQuoteItem) !== 1) toggleQuoteTabs('1')()
        break
      case 'life':
        if (parseInt(activeQuoteItem) !== 2) toggleQuoteTabs('2')()
        break
      case 'senior':
        if (parseInt(activeQuoteItem) !== 3) toggleQuoteTabs('3')()
        break
      case 'small-biz':
        if (parseInt(activeQuoteItem) !== 4) toggleQuoteTabs('4')()
        break
      default:
        break
    }
  }

  useEffect(() => {
    handleExternalTabChange()
  }, [props.insuranceType, activeQuoteItem])

  return (
    <div
      style={{
        backgroundImage: `url(${
          BG_IMGS[isSmallBiz ? 'business' : 'individual']
        })`,
        backgroundPositionY: 'center',
      }}
      className="QuotationTabsComponent section-60 section-sm-90 bg-athens-gray bg-image bg-image-sm-hide"
    >
      <div className="shell">
        <div className="range range-sm-right">
          <div className="cell-sm-8 cell-md-7 cell-lg-7">
            <div
              id="tabs-3"
              className="tabs-custom tabs-horizontal tabs-line tabs-custom-horizontal"
            >
              <MDBNav className="nav-tabs">
                <MDBNavItem className={activeQuoteItem === '1' ? 'active' : ''}>
                  <MDBNavLink
                    link
                    to="#quote-health-insurance"
                    active={activeQuoteItem === '1'}
                    onClick={toggleQuoteTabs('1')}
                    role="tab"
                  >
                    HEALTH INSURANCE
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem className={activeQuoteItem === '2' ? 'active' : ''}>
                  <MDBNavLink
                    link
                    to="#quote-life-insurance"
                    active={activeQuoteItem === '2'}
                    onClick={toggleQuoteTabs('2')}
                    role="tab"
                  >
                    LIFE INSURANCE
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem className={activeQuoteItem === '3' ? 'active' : ''}>
                  <MDBNavLink
                    link
                    to="#quote-senior-insurance"
                    active={activeQuoteItem === '3'}
                    onClick={toggleQuoteTabs('3')}
                    role="tab"
                  >
                    SENIOR INSURANCE
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem className={activeQuoteItem === '4' ? 'active' : ''}>
                  <MDBNavLink
                    link
                    to="#quote-small-biz-insurance"
                    active={activeQuoteItem === '4'}
                    onClick={toggleQuoteTabs('4')}
                    role="tab"
                  >
                    SMALL BUSINESS INSURANCE
                  </MDBNavLink>
                </MDBNavItem>
              </MDBNav>
              <MDBTabContent
                activeItem={activeQuoteItem}
                className="tab-content text-gray-base"
              >
                <MDBTabPane tabId="1" role="tabpanel" className="fade in">
                  <h2>
                    <span className="sub-head-small">
                      Health Insurance Quote
                    </span>
                  </h2>
                  <IndividualQuote
                    onSuccess={props.onSuccess}
                    insuranceType={'Health'}
                  />
                </MDBTabPane>
                <MDBTabPane tabId="2" role="tabpanel" className="fade in">
                  <h2>
                    <span className="sub-head-small">Life Insurance Quote</span>
                  </h2>
                  <IndividualQuote
                    onSuccess={props.onSuccess}
                    insuranceType={'Life'}
                  />
                </MDBTabPane>
                <MDBTabPane tabId="3" role="tabpanel" className="fade in">
                  <h2>
                    <span className="sub-head-small">
                      Senior Insurance Quote
                    </span>
                  </h2>
                  <IndividualQuote
                    onSuccess={props.onSuccess}
                    insuranceType={'Senior'}
                  />
                </MDBTabPane>
                <MDBTabPane tabId="4" role="tabpanel" className="fade in">
                  <h2>
                    <span className="sub-head-small">Small Business Quote</span>
                  </h2>
                  <BusinessQuote onSuccess={props.onSuccess} />
                </MDBTabPane>
              </MDBTabContent>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(QuotationTabs)
